import { render, staticRenderFns } from "./ManageDiscountsAndGroupsOfDiscounts.vue?vue&type=template&id=25c5475a&scoped=true&"
import script from "./ManageDiscountsAndGroupsOfDiscounts.vue?vue&type=script&lang=js&"
export * from "./ManageDiscountsAndGroupsOfDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./ManageDiscountsAndGroupsOfDiscounts.vue?vue&type=style&index=0&id=25c5475a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5475a",
  null
  
)

export default component.exports